module.exports = function ClientFilterSubscribeRequest(filter, selector) {
    this.filter = filter;
    this.selector = selector;
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control-client/client-filter-subscribe-request.js
// module id = 434
// module chunks = 1